import { Card } from "./card";

export class Stack {
    cards : Card[];
    constructor () {
        this.cards = [];
    }
}